<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-card>
      <b-card-title style="text-align: center">SEVAC</b-card-title>
      <b-col md="12" style="text-align: end">
        <b-button size="sm" variant="primary" @click="editorTrimestre=true">Nuevo trimestre</b-button>
        
      </b-col>
      <br>      
      <b-list-group>
        <b-list-group-item  v-for="(element, index) in trimestres" :key="index">    
          <b-link  :to="'/tesoreria/trimestre/'+element._id+'/sevac'">{{element.nombre}}</b-link >
          <b-button-group  size="sm" class="pull-right">         
               <b-button size="sm" :variant="element.visible ? 'outline-success' : 'outline-secondary'" @click="visible(element._id)">
              <i :class="element.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
            </b-button> 
          <b-button variant="outline-secondary" v-b-tooltip.hover title="Modificar" @click="editar(element)">
            <i class="fa fa-pencil fa-lg"></i>
          </b-button>
          <!-- <b-button variant="outline-secondary" @click="eliminar(element._id, element.nombre)"  v-b-tooltip.hover title="Eliminar">
            <i class="fa fa-trash fa-lg"></i>
          </b-button> -->
          </b-button-group>
        </b-list-group-item>   
      </b-list-group>    
    </b-card>
    <formTrimestre
      v-if="editorTrimestre"
      :mostrar="editorTrimestre"
      :trimestre="trimestre"
      @cancelar="editorTrimestre=false, trimestre=null"
      @actualizarTrimestre="actualizarTrimestre"
    />
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import formTrimestre from "./modalTrimestre.vue"
import loader from "../Loader.vue"

export default {
  name: 'Trimestres',
  components: { formTrimestre, loader },
  computed: {
    ...mapGetters(["httpURL","sessionToken","permisos","role" ]),
    // puedeAdministrar(){
    //   if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 228) >= 0 ) return true;
    //   else return false;
    // },
    
  },
   validations:{
     nombre: { required }
  },
  data: function () {
    return {
      titulo: this.$route.name,
      enviando: false,
      trimestres: [],
      editorTrimestre:false,
      trimestre:null
    }
  },
  created(){

      // if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero == 227) == -1 ) {
      
      //  this.$router.go(-1);
      // }
      this.enviando = true;
      
      axios.get(this.httpURL+'/tesoreria/trimestres',{headers:{token:this.sessionToken}})
              .then(res => {
                  this.trimestres = res.data.trimestres;
                  this.enviando = false;
              })
              .catch(error => {
                  if(error){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
  },
  methods: {
    editar(trimestre){
      this.trimestre = trimestre;
      this.editorTrimestre=true;
    },   
    actualizarTrimestre(trimestre){
       this.editorTrimestre=false;
        let index = this.trimestres.findIndex(x=> x._id==trimestre._id)
        if(index!=-1){
          this.trimestres[index].nombre=trimestre.nombre
        }
        else this.trimestres.push(trimestre)
    },
    visible(id){
      this.enviando=true;
      axios.put(this.httpURL +"/tesoreria/trimestre/"+id+"/visible",
        {},{ headers: { token: this.sessionToken } })
        .then(res => {
          this.enviando = false;
          if (res.data.ok) {
            let index = this.trimestres.findIndex(x=>x._id==id)
            if(index!=-1)this.trimestres[index].visible = res.data.visible
            this.$notify({ group: "foo", type: "success",duration: 2500,speed: 1000,text: res.data.mensaje });
          }
        })
        .catch(error => {
          this.$notify({ group: "foo",type: "error",duration: 2500, speed: 1000, text: "No se pudo eliminar la sección."});
          this.enviando = false;
        })   
    },
    eliminar(id,nombre){
        swal({ 
          text: `Al eliminar el trimestre, se eliminarán todas las preguntas de forma permanente. ¿Está seguro de eliminar el trimestre ${nombre}? `,
          icon: "warning",
          buttons: true,
          dangerMode: true,

        }).then(willDelete => {
          if (willDelete) {
            this.enviando=true;
            axios.delete(this.httpURL +"/tesoreria/trimestre/"+id,
                { headers: { token: this.sessionToken } })
              .then(res => {
                this.enviando = false;
                if (res.data.ok) {
                  this.$notify({ group: "foo", type: "success",duration: 2500,speed: 1000, text: res.data.mensaje });
                  let index = this.trimestres.findIndex(x=>x._id==trimestre._id)
                  if(index!=-1)this.trimestres.splice(index,1)
                }
              })
              .catch(error => {
                this.$notify({group: "foo", type: "error", duration: 2500, speed: 1000, text: "No se pudo eliminar la sección."});
                this.enviando = false;
              });
           
          }
        })      
    },
   
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
